export default __webpack_public_path__ + "static/FAM1344W000-6f483451cafea516c448415017583242.jpg";